import React from 'react'
import { TabNav } from '~/components/shared/TabNav'
import TabNavButtons from './TabNavButtons'
import TabNavPanelContainer from './TabNavPanelContainer'
import CoachDashboardProvider from './CoachDashboardProvider'

const CoachDashboard = () => {
  return (
    <div>
      <TabNav defaultActiveTab="prioritized_tasks" mobileMode="dropdown">
        <TabNavButtons />
        <TabNavPanelContainer />
      </TabNav>
    </div>
  )
}

const Index = (props) => {
  return (
    <CoachDashboardProvider {...props}>
      <CoachDashboard />
    </CoachDashboardProvider>
  )
}
export default Index
